RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const InsightsLayoutMixin = {
        getErrorElement: function () {
            const me = this;
            return me.ui.noPosts;
        },

        getEarliestPostDataDateString: function () {
            const me = this;
            return me.postHistorySince;
        },

        // Load data that figures out if we have results; the views that use this mixin
        // can use that info to show / hide a no results page.
        loadData: function () {
            const deferred = new $.Deferred();
            const me = this;

            const props = me.getProps();
            const property = (props.objectType === RivalIQ.enums.insightsObjectType.storyDay ? 'days_with_story' : 'count');
            const definition = App.utils.createInsightsMetric(props.objectType, _.defaults({
                dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                property: property
            }, props));

            $.when.apply($, [
                new RivalIQ.models.MetricDefinition(definition).fetch(),
                RivalIQ.data.privateMetadata.fetch(props)
            ]).then(function (metric, privateMetadata) {
                me.metric = metric;
                me.hasPosts = (metric.getValue({
                    format: false
                }) > 0);
                me.errorObj = null;
                me.errorName = null;

                const company = _.find(privateMetadata.companies, {
                    id: props.companyId
                });
                me.postHistorySince = _.get(company, ['post_history_since']);
                me.earliestStoryPullData = _.get(privateMetadata.instagramPresences, [props.presenceId, 'first_active_stories_fetch_at']);
            }).fail(function (xhr) {
                me.metric = null;
                me.hasPosts = null;
                me.errorObj = _.get(xhr, 'errorObj', xhr.status);
                me.errorName = _.get(xhr, 'errorName', xhr.status);
            }).always(deferred.resolve);

            return deferred;
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        onRenderLoaded: function () {
            const me = this;
            me.showToolbars();
            me.toggleView();
        },
        toggleView: function () {
            const me = this;

            me.requestRenderedFrame(function () {
                if (me.errorObj) {
                    me.showTryAgainMessage(me.getMessageForError(me.errorObj), true);
                    me.ui.widgets.hide();
                } else if (!me.hasPosts) {
                    me.showNoResultsMessage();
                    me.ui.widgets.hide();
                } else {
                    me.getErrorElement().hide();
                    me.ui.widgets.show();
                }
            });
        },

        getNoResultsImageSrc: function (source) {
            let imgName = '';
            if (source === RivalIQ.enums.sources.TWITTER_INSIGHTS) {
                imgName = 'twitter-auth.svg';
            } else if (source === RivalIQ.enums.sources.FACEBOOK_INSIGHTS) {
                imgName = 'facebook-insights-auth.svg';
            } else if (source === RivalIQ.enums.sources.LINKEDIN_INSIGHTS) {
                imgName = 'linkedin-insights-auth.svg';
            } else {
                imgName = 'instagram-auth.svg';
            }

            return `/images/${imgName}`;
        },

        showNoResultsMessage: function () {
            const me = this;
            const View = RivalIQ.views.ItemView;

            const hasSearchTerm = !_.isEmpty(me.getProp('searchTerm'));
            const hasMediaTypeFilter = !_.isEmpty(me.getProp('mediaTypeFilter'));
            const hasPostTagFilter = !_.isEmpty(me.getProp('postTagIds'));

            let message;
            let contextMessage;
            let helpMessage;
            let helpLink;


            if (hasSearchTerm || hasMediaTypeFilter || hasPostTagFilter) {
                message = 'There are no posts matching your current query and filters during the selected time period.';
            } else {
                const channel = RivalIQ.data.channels.get(me.getProp('source')).getChannel();
                if (channel === RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.LINKEDIN].channel) {
                    message = `${me.options.dashboardModel.presence.attributes.name} had no LinkedIn updates during the selected time period.`;
                } else {
                    const companyId = me.getProp('companyId');
                    const companyName = RivalIQ.state.landscape.getCompanyById(companyId).attributes.name;
                    message = `${companyName} had no Facebook posts during the selected time period.`;

                }
            }
            const source = _.get(me, ['dashboardModel', 'configurationProps', 'source']);
            const imgSrc = me.getNoResultsImageSrc(source);
            const el = me.getErrorElement();
            new View({
                el: el,
                template: '#insightsSearchableLayoutErrorTemplate',
                model: new Backbone.Model({
                    imgSrc: imgSrc,
                    message: message,
                    contextMessage: contextMessage,
                    helpMessage: helpMessage,
                    helpLink: helpLink
                })
            }).render();
            el.show();
        },

        refresh: function () {
            const me = this;
            me.toggleView();
        }
    };

    views.InsightsLayout = Dashboard.views.CurationLayout.mixin({
        template: '#dashboardSocialPostsLayoutTemplate',

        className: 'flex-toolbar-layout',

        ui: {
            noPosts: '.no-posts',
            widgets: '.dashboard-regions'
        },

        mixins: {
            InsightsLayoutMixin: InsightsLayoutMixin,
            SearchableLayout: RivalIQ.apps.Dashboard.mixins.SearchableLayout
        },

        showSearchControls: _.constant(true),

        showLeftToolbarActions: function () {
            const me = this;

            const contentType = (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post ? 'Post' : 'Story');
            if (me.showSearchControls()) {
                me.leftActions.show(new App.views.SearchBar({
                    dashboardModel: me.dashboardModel,
                    placeholder: RivalIQ.str('instagram_insights_search_placeholder_description', contentType)
                }), {
                    preventDestroy: true
                });
            }
        },

        showActions: function () {
            const me = this;

            if (me.showSearchControls()) {
                me.showExportDropdown();
            }
        }
    });

    views.TwitterInsightsLayout = views.InsightsLayout.extend({

        showNoResultsMessage: function () {
            const me = this;
            const View = RivalIQ.views.ItemView;

            const hasSearchTerm = !_.isEmpty(me.getProp('searchTerm'));
            const hasMediaTypeFilter = !_.isEmpty(me.getProp('mediaTypeFilter'));
            const hasPostTagFilter = !_.isEmpty(me.getProp('postTagIds'));
            const hasTweetTypeFilter = !_.isEmpty(me.getProp('tweetTypeFilter'));

            let message;
            let contextMessage;

            if (hasSearchTerm || hasMediaTypeFilter || hasTweetTypeFilter || hasPostTagFilter) {
                message = 'There are no tweets matching your current query and filters during the selected time period.';
            } else if (me.options && me.options.dashboardModel) {
                message = `@${me.options.dashboardModel.getCuration().presence.attributes.screen_name} had no tweets during the selected time period.`;
            }

            const earliestPostDataDateString = me.getEarliestPostDataDateString();
            const earliestPostData = moment.utc(earliestPostDataDateString);
            if (moment.utc(me.getProp('timePeriod').mainPeriodStart).isBefore(earliestPostData)) {
                const earliestPostDataToDisplay = moment.utc(earliestPostData).format('L');
                contextMessage = `Twitter gives limited analytics data access to historical tweets. The earliest private tweet data we have for this presence begins on ${earliestPostDataToDisplay}.`;
            }

            const helpMessage = `Why aren't my tweets showing up?`;
            const helpLink = 'https://help.rivaliq.com/en/articles/3406501';

            const el = me.getErrorElement();
            new View({
                el: el,
                template: '#insightsSearchableLayoutErrorTemplate',
                model: new Backbone.Model({
                    imgSrc: me.getNoResultsImageSrc(RivalIQ.enums.sources.TWITTER_INSIGHTS),
                    message: message,
                    contextMessage: contextMessage,
                    helpMessage: helpMessage,
                    helpLink: helpLink
                })
            }).render();
            el.show();
        }
    });

    views.InstagramInsightsLayout = views.InsightsLayout.extend({

        showNoResultsMessage: function () {
            const me = this;
            const View = RivalIQ.views.ItemView;

            const hasSearchTerm = !_.isEmpty(me.getProp('searchTerm'));
            const hasMediaTypeFilter = !_.isEmpty(me.getProp('mediaTypeFilter'));
            const hasPostTagFilter = !_.isEmpty(me.getProp('postTagIds'));

            let message;
            let contextMessage;
            let helpMessage;
            let helpLink;
            const curation = me.options.dashboardModel.getCuration();
            const handleName = curation.presence.attributes.sources[RivalIQ.enums.sources.INSTAGRAM_INSIGHTS].handle;
            if (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post) {

                if (hasSearchTerm || hasMediaTypeFilter || hasPostTagFilter) {
                    message = 'There are no posts matching your current query and filters during the selected time period.';
                } else {
                    message = `@${handleName} had no Instagram posts during the selected time period.`;
                }

                const earliestPostDataDateString = me.getEarliestPostDataDateString();
                const earliestPostData = moment.utc(earliestPostDataDateString);
                if (moment.utc(me.getProp('timePeriod').mainPeriodStart).isBefore(earliestPostData)) {
                    contextMessage = 'Instagram does not track insights on posts posted before you became a business account.';
                }

                helpMessage = `Why aren't my posts showing up?`;
                helpLink = 'https://help.rivaliq.com/frequently-asked-questions/why-arent-all-my-instagram-posts-showing-up';
            } else {
                if (hasSearchTerm) {
                    message = 'No Stories matching the query were posted during the selected time period.';
                } else {
                    message = `${handleName} had no Instagram Stories during the selected time period.`;
                    const earliestStoryPullData = moment.utc(me.earliestStoryPullData);
                    if (moment.utc(me.getProp('timePeriod').mainPeriodStart).isBefore(earliestStoryPullData)) {
                        contextMessage = `Instagram does not give access to historical Stories. We began tracking the Stories you post on ${earliestStoryPullData.format('L')}.`;
                    }
                }

                helpMessage = `Why aren't my Stories showing up?`;
                helpLink = 'https://help.rivaliq.com/frequently-asked-questions/why-arent-my-instagram-stories-showing-up';
            }

            const el = me.getErrorElement();
            new View({
                el: el,
                template: '#insightsSearchableLayoutErrorTemplate',
                model: new Backbone.Model({
                    imgSrc: '/images/instagram-auth.svg',
                    message: message,
                    contextMessage: contextMessage,
                    helpMessage: helpMessage,
                    helpLink: helpLink
                })
            }).render();
            el.show();
        },

        showSearchControls: function () {
            const me = this;

            const objectType = me.getProp('objectType');
            const isPostObjectType = (objectType === RivalIQ.enums.insightsObjectType.post);
            const widget = {
                curation: me.dashboardModel
            };

            return !(isPostObjectType && RivalIQ.apps.Insights.utils.isLoadingInstagramPromotedPosts(widget));
        }
    });

    views.InsightsDetailsLayout = Dashboard.views.DetailsLayout.mixin({
        className: 'flex-toolbar-layout details',

        template: '#insightsWidgetDetailLayoutTemplate',

        ui: {
            noResults: '.no-results'
        },

        widgetRegion: 'body',

        mixins: {
            SearchableLayout: Dashboard.mixins.SearchableLayout
        },

        getErrorElement: function () {
            const me = this;
            return me.ui.noResults;
        },

        getEarliestPostDataDateString: function () {
            const me = this;
            const postHistorySince = me.dashboardModel.curation.presence.get('post_history_since');
            return postHistorySince;
        },

        getNoResultsImageSrc: InsightsLayoutMixin.getNoResultsImageSrc,

        showNoPostsMessage: function () {
            const me = this;

            const source = me.getProp('source');
            const channel = RivalIQ.data.channels.get(source).getChannel();
            if (channel === RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.TWITTER_INSIGHTS].channel) {
                views.TwitterInsightsLayout.prototype.showNoResultsMessage.apply(me, arguments);
            } else if (channel === RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.INSTAGRAM_INSIGHTS].channel) {
                views.InstagramInsightsLayout.prototype.showNoResultsMessage.apply(me, arguments);
            } else {
                Dashboard.mixins.SearchableLayout.showNoPostsMessage.apply(me, arguments);
            }
        },

        showLeftToolbarActions: function () {
            const me = this;

            me.showBackLink();

            const navToolbar = new App.views.SearchBar({
                view: me,
                dashboardModel: me.dashboardModel
            });

            // the preventDestroy is needed so we don't clear out the backlink
            me.leftActions.show(navToolbar, {
                preventDestroy: true
            });
        },

        showBackLink: function () {
            const me = this;

            me.leftActions.show(new RivalIQ.views.Link({
                className: 'btn btn-default btn-back-link',
                linkName: '<span class="fa fa-chevron-left"></span>',
                attributes: {
                    href: '#'
                },
                action: function () {
                    RivalIQ.execute('history:navigate', me.dashboardModel.getBackPath(), {
                        trigger: true
                    });
                }
            }), {
                preventDestroy: true
            });
        },

        showToolbarActions: function () {
            const me = this;
            me.showExportDropdown();
        }
    });

}, window.moment);
